<div class="feedback-comment" [ngClass]="{embedded: embedded}">
    <div class="text" *ngIf="!task.task && !embedded && task.is_title">
        <div class="title my-color-blue" [innerHTML]="(for_manager ? task.title_for_manager : (for_coach ? task.title_for_coach : task.title)) | safeHtml"></div>
    </div>

    <app-journey-list-template-checkbox
            *ngIf="embedded && !readonly" style="margin: 1rem 0 1.6rem 0;"
            [task]="task" [for_manager]="for_manager" [for_coach]="for_coach"></app-journey-list-template-checkbox>

    <app-journey-list-template-checkbox
            *ngIf="task.task && !embedded" class="blue"
            [task]="task" [for_manager]="for_manager" [for_coach]="for_coach" [disabled]="readonly"></app-journey-list-template-checkbox>

    <div *ngIf="!!task.text && !embedded" class="text"><strong>{{for_manager ? task.text_for_manager : (for_coach ? task.text_for_coach : task.text) }}</strong></div>
    <textarea *ngIf="!readonly" (input)="onChange($event)" aria-label="" class="swiper-no-swiping"
              [(ngModel)]="task.details.custom_textbox.value.value"></textarea>
    <div *ngIf="readonly" class="body-text" [innerHTML]="task.details.custom_textbox.value.output"></div>
</div>
